<template>
    <!--<div id="app" style="display: flex; flex-flow: column; height: 700px;">-->
    <div id="app" style="display: flex; flex-flow: column; height: 100vh; min-height: 350px">

        <top-bar
                @placeSelected="showPlace"
                @promotionSelected="onPromotionSelected"
                :map="mapa"
                @mapReset="setDefaultMapBounds"
                :searchValue.sync="placeSearcherValue"
        />


        <div style="position: relative; flex: 1 1" class="locator__map-container" ref="mapContainer">
            <div :class="{'locator__map-container-loader': true, 'hide': loaderHidden}">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <places-list
                    :map="mapa"
                    :visible="placeListVisible"
                    ref="placesList"
                    v-bind:class="{'visible-mobile': mobileList}"
            />

            <google-map
                    :zoom.sync="zoom"
                    :center="center"
                    style="width: 100%; height: 100%"
                    ref="mapa"
                    @mapCreated="onMapCreated"
                    :mapStyles="mapStyles"
                    @bounds_changed="onBoundsChanged"
                    v-if="institutionsLoaded"
            />

            <div class="locator__show-route-btn" @click="openRouteToActiveInstitution"
                 v-if="$store.state.selectedInstitution">
                <span>{{ $t('calculate_route') }}</span>
            </div>

            <div class="locator__nav-btns">
                <div @click="setDefaultMapBounds" class="locator__nav-btn">
                    <img v-bind:src="getIconMap()" alt="">
                </div>
                <div @click="zoom += 1" class="locator__nav-btn">
                    <img width="18px" v-bind:src="getIconPlus()" alt="">
                </div>
                <div @click="zoom -= 1" class="locator__nav-btn">
                    <img width="18px" v-bind:src="getIconMinus()" alt="">
                </div>
            </div>
        </div>

        <div class="locator__mobile-nav">
            <div @click="showPlaceList(true)" class="locator__mobile-nav-btn">Lista</div>
            <div @click="hidePlaceList" class="locator__mobile-nav-btn">Mapa</div>
        </div>
    </div>
</template>

<script>
    import TopBar from './components/top-bar'
    import PlacesList from './components/places-list'
    import Place from './components/place'
    import mapStyles from './styles/mapStyle'
    import Url from 'url-parse'
    import mapBounds from './langs/mapBounds'
    import EventBus from './eventBus'
    import queryParam from './util/queryParam'

    export default {
        components: {
            TopBar,
            PlacesList,
            Place
        },
        name: 'app',
        data() {
            let center;
            if (this.$appLang === 'UA') {
                center = {lat: 48.97938858209427, lng: 31.470326541743532};
            } else {
                center = {lat: 51.9570078, lng: 17.8513354};
            }
            return {
                zoom: 6,
                isDefaultViewport: true,
                boundsBeforeSelect: {},
                zoomBeforeSelect: 7,
                center: center,
                // startBounds: [
                //     // Corners of default viewport
                //     {lat: 54.8267131, lng: 13.5729803},
                //     {lat: 55.309406, lng: 24.0474823},
                //     {lat: 48.7940005, lng: 25.0460633},
                //     {lat: 48.8418705, lng: 15.8229933}
                // ],
                placeListVisible: false,
                mapa: null,
                markersCountIfNoOneExist: 1,
                mapStyles: mapStyles,
                zoomToShowInstitutionList: 10,
                zoomOnMarkerSelect: 15,
                mobileList: false,
                defaultViewport: {},
                placeSearcherValue: '',
                loaderHidden: false,
                zoomTimeout: null,
                boundsChangedTimeout: null,
            }
        },
        watch: {
            loaderHidden(val) {
                if (!val) return;
                if (this.$appLang === 'LT') return;
                let urlInitialSettings = this.getUrlSettings();
                if (urlInitialSettings) {
                    setTimeout(() => {
                        this.center = urlInitialSettings.center;
                        this.zoom = urlInitialSettings.zoom;
                    }, 1000);

                    // setTimeout(() => {
                    this.$store.commit('setSelectedPromotionsInit', urlInitialSettings.promotions);
                    // }, 10000);

                    // for(let promotion of urlInitialSettings.promotions) {
                    //   this.$store.commit('selectPromotion', promotion);
                    // }
                }
            },
            zoom(newVal, oldVal) {
                clearTimeout(this.zoomTimeout);
                this.zoomTimeout = setTimeout(() => {
                    if (this.zoom < this.zoomToShowInstitutionList) {
                        this.hidePlaceList();
                        this.$store.commit('selectInstitution', null);
                    } else {
                        this.showPlaceList();
                    }

                    if (newVal < oldVal) {
                        this.placeSearcherValue = '';
                        if (this.$store.state.selectedInstitution) {
                            this.boundsBeforeSelect = null;
                            this.$store.commit('selectInstitution', null)
                        }
                    }
                }, 500);

            },
            '$store.state.selectedInstitution'(institutionData) {
                if (institutionData) {
                    this.showInstitution(institutionData)
                } else {
                    this.setLastBounds();
                    if (isMobile()) this.hidePlaceList();
                }
            },
            // '$store.state.selectedPromotions'() {
            // let place = {
            //   geometry: {
            //     viewport: this.getMapBounds()
            //   }
            // }
            // this.showPlace(place, false);
            // },
            '$store.state.institutions'() {
                setTimeout(() => {
                    this.loaderHidden = true;
                    if(this.getUrlParam('id')) {
                      this.findInstitution(this.getUrlParam('id'));
                    }
                }, 500);
            }
        },
        computed: {
            institutions() {
                return this.$store.state.institutions;
            },
            institutionsLoaded() {
                return this.$store.state.institutionsLoaded;
            },
            startBounds() {
                return mapBounds[this.$appLang.toLowerCase()].bounds
            },
            initialZoom() {
                if (this.$appLang == 'EE') {
                    return 8;
                } else {
                    return 3;
                }
            }
        },
        methods: {
            mapReset() {
                this.setDefaultMapBounds();
                // this.zoom = 7;
            },
            onMapCreated(map) {
                this.mapa = map;

                parent.dataLayer.push({
                  event: "mapka-zaladowana"
                });

                var that = this
                map.addListener('tilesloaded', function () {
                    let promotionId = queryParam('promotion')
                    if (null == promotionId) {
                        return;
                    }

                    let promotions = that.$store.getters.promotions;
                    let promotionSelected;
                    let unselected = [];
                    for (let index in promotions) {
                        if (promotionId != promotions[index].id) {
                            unselected.push(promotions[index]);
                            continue;
                        }
                        promotionSelected = promotions[index];
                    }

                    if (undefined == promotionSelected) {
                        return;
                    }

                    setTimeout(() => {
                        EventBus.$emit('MAP_READY', {
                            promotionSelected: promotionSelected,
                            promotionUnselect: unselected
                        })
                    }, 100)

                });

                setTimeout(() => {
                    this.setDefaultMapBounds();
                }, 500)
                // this.setDefaultMapBounds();
                // this.mapa.setZoom(7);
            },
            onPromotionSelected(promotion) {
                if (promotion == null) this.$store.commit('selectPromotion', 0);
                else if (promotion.id) this.$store.commit('selectPromotion', promotion.id);
                this.onBoundsChanged();
            },
            onBoundsChanged(newVal, oldVal) {
                clearTimeout(this.boundsChangedTimeout);
                this.boundsChangedTimeout = setTimeout(() => {
                    // if(this.zoom >= this.zoomToShowInstitutionList) {
                    //   this.showPlaceList()
                    // }

                    this.$store.commit('updateListVisibility', this.mapa.getBounds());
                }, 500)
            },
            openRouteToActiveInstitution() {
                let baseUrl = 'https://www.google.com/maps/search/?api=1&query=';
                let institutionPosition = this.getLatLngObj({
                    lat: this.$store.state.selectedInstitution.institution.lat,
                    lng: this.$store.state.selectedInstitution.institution.lng
                });
                let url = baseUrl + institutionPosition.lat() + ',' + institutionPosition.lng();
                window.open(url);
            },
            setLastBounds() {
                if (this.boundsBeforeSelect) {
                    this.mapa.fitBounds(this.boundsBeforeSelect, 0);
                    this.mapa.setZoom(this.zoomBeforeSelect)
                }
            },
            showInstitution(institutionData) {
                this.showPlaceList(true);
                this.boundsBeforeSelect = this.getMapBounds();
                this.zoomBeforeSelect = this.zoom;

                if (this.zoom < this.zoomOnMarkerSelect) {
                    this.mapa.setZoom(this.zoomOnMarkerSelect);
                    let institutionPosition = this.getLatLngObj({
                        lat: institutionData.institution.lat,
                        lng: institutionData.institution.lng
                    });
                    this.mapa.setCenter(institutionPosition);
                }
            },
            findInstitution(institutionID) {
              let selected = this.$store.state.institutions.find(obj => obj.institution.id === parseInt(institutionID));
              this.$store.commit('selectInstitution', selected.institution);
              return selected;
            },
            getUrlParam(param) {
              const urlParams = new URLSearchParams(window.location.search);
              return urlParams.get(param) ? urlParams.get(param) : false;
            },
            showPlaceList(force = false) {
                if (!isMobile() || force) {
                    this.placeListVisible = true;
                }
            },
            hidePlaceList() {
                this.placeListVisible = false;
            },
            showPlace(place, zoomFix = true) {
                if (this.$store.state.selectedInstitution) {
                    this.boundsBeforeSelect = null;
                    this.$store.commit('selectInstitution', null);
                }
                // console.log(place);
                if (!place.geometry) return;
                let viewport = place.geometry.viewport;

                let markers = this.getNearbyMarkersFromInstitutions(viewport.getCenter());
                if (!markers) return;
                let withZoom = false;
                if (this.viewportContainMarker(viewport, markers) && zoomFix) {
                    withZoom = true;
                }
                this.extendViewportWithMarkers(viewport, markers);

                this.mapa.fitBounds(viewport, 0);
                if (place.name == "Tarnów") {
                    withZoom = false;
                }
                if (withZoom) {
                    this.mapa.setCenter(place.geometry.location)
                    this.mapa.setZoom(this.mapa.getZoom() + 0.5);
                }

                // let listener = this.mapa.addListener('bounds_changed', () => {
                //   console.log('bounds changed');
                //   this.mapa.fitBounds(viewport, 0);
                //   listener.remove();
                // })
            },
            getMapBounds() {
                return this.mapa.getBounds();
            },
            getNearbyMarkersFromInstitutions(latLngCenter) {
                let markers = [];
                for (let institution of this.institutions) {
                    if (!this.institutionHasPosition(institution)) continue;
                    if (!this.institutionMarkerIsVisible(institution)) continue;
                    let institutionPos = this.getInstitutionPosition(institution);
                    let distanceFromCenter = this.computeDistanceBetweenPoints(institutionPos, latLngCenter);

                    markers.push({
                        position: institutionPos,
                        distance: distanceFromCenter
                    });
                }

                return this.sortMarkersByDistance(markers);
            },
            getInstitutionPosition(institutionObj) {
                let pos = {lat: institutionObj.institution.lat, lng: institutionObj.institution.lng};
                return this.getLatLngObj(pos);
            },
            getLatLngObj(obj) {
                return new google.maps.LatLng(obj.lat, obj.lng);
            },
            institutionHasPosition(institutionObj) {
                return institutionObj.institution.lat && institutionObj.institution.lng;
            },
            computeDistanceBetweenPoints(point1, point2) {
                return google.maps.geometry.spherical.computeDistanceBetween(point1, point2)
            },
            sortMarkersByDistance(institutionArray, desc = true) {
                institutionArray.sort((a, b) => {
                    let aDistance = a.distance;
                    let bDistance = b.distance;
                    let result = 0;
                    if (aDistance < bDistance) result = -1;
                    if (aDistance > bDistance) result = 1;

                    if (!desc) result *= -1;
                    return result;
                });
                return institutionArray;
            },
            extendViewportWithMarkers(viewport, markers) {
                if (!this.viewportContainMarker(viewport, markers)) {
                    let markersCount = Math.min(this.markersCountIfNoOneExist, markers.length);
                    for (let i = 0; i < markersCount; i++) {
                        viewport.extend(markers[i].position)
                    }
                }
            },
            viewportContainMarker(viewport, markers) {
                return viewport.contains(markers[0].position)
            },
            setDefaultMapBounds() {
                this.placeSearcherValue = ''
                this.$googleApiPromise.then((google) => {
                    this.mapa.fitBounds(this.defaultViewport, 0)
                })
            },
            institutionMarkerIsVisible(institutionObj) {
                return !institutionObj.markerHidden;
            },
            getUrlSettings() {
                let parsedUrl = new Url(document.referrer, true);

                if (parsedUrl.query) {
                    let explodeCenter = [];
                    if (parsedUrl.query.locator_center) {
                        explodeCenter = parsedUrl.query.locator_center.split(',');
                    }

                    let promotions = []
                    if (parsedUrl.query.locator_promotions) {
                        promotions = parsedUrl.query.locator_promotions.split(';');
                        promotions = promotions.map(item => {
                            if (item.indexOf(',') > 0) {
                                return item.split(',');
                            }
                            return item;
                        })
                    }

                    let center = this.center;
                    if (explodeCenter.length === 2) {
                        center = {
                            lat: parseFloat(explodeCenter[0]),
                            lng: parseFloat(explodeCenter[1])
                        }
                    }

                    return {
                        center: center,
                        zoom: parseFloat(parsedUrl.query.locator_zoom) || this.zoom,
                        promotions
                    }
                }
                return {}
            },
            getIconMap() {
                if (this.$siteVariantImages[this.$siteVariant] && this.$siteVariantImages[this.$siteVariant]['map']) {
                    return this.$siteVariantImages[this.$siteVariant]['map'];
                }
                return require('./assets/ikonka-polska.png');
            },
            getIconPlus() {
                if (this.$siteVariantImages[this.$siteVariant] && this.$siteVariantImages[this.$siteVariant]['plus']) {
                    return this.$siteVariantImages[this.$siteVariant]['plus'];
                }
                return require('./assets/iconPlus2.svg')
            },
            getIconMinus() {
                if (this.$siteVariantImages[this.$siteVariant] && this.$siteVariantImages[this.$siteVariant]['minus']) {
                    return this.$siteVariantImages[this.$siteVariant]['minus'];
                }
                return require('./assets/-.svg')
            }
        },
        mounted() {
            window.isMobile = function () {
                return window.innerWidth <= 800;
            }

            function closeTab(el) {
                el.addEventListener('click', () => {
                    EventBus.$emit('CLOSE_OTHER', true)
                })
            }

            document.addEventListener("DOMContentLoaded", function () {
                let body = document.querySelector('.locator__map-container');
                closeTab(body)


            });

            this.$googleApiPromise.then(google => {
                this.defaultViewport = new google.maps.LatLngBounds();

                for (let point of this.startBounds) {
                    this.defaultViewport.extend(point);
                }
            })
        }
    }
</script>

<style scoped lang="scss">

</style>
